const translations = { options: 'Options', selectChecklist: 'Checklist selection', checklist: 'Checklist' }

export default translations
